import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { RegistruService } from '../registru.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-edit-registru',
    templateUrl: './edit-registru.component.html',
    styleUrls: ['./edit-registru.component.scss']
})
export class EditRegistruComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    serieType$: any = [];
    judete!: Generic[];

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    tipPersoanaOptions = [
        { label: 'Fizică', value: 'fizica' },
        { label: 'Juridică', value: 'juridica' },
    ];

    taxOptions = [
        { label: 'Da', value: true },
        { label: 'Nu', value: false },
    ];

    form!: FormGroup;

    formCertificatUrbanism: FormGroup = new FormGroup({
        numar_certificat: new FormControl(this.inputData.data.numar_certificat, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_imobil?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_imobil?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_imobil?.sector),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        numar_cadastral: new FormControl(this.inputData.data.nr_cadastral, Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        valabilitate: new FormControl(this.createDate(this.inputData.data.valability), Validators.required),
        // taxa_achitata: new FormControl(this.inputData.data.taxa_achitata, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formAutorizatiiConstruire: FormGroup = new FormGroup({
        numar_autorizatie: new FormControl(this.inputData.data.registru_number, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_imobil?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_imobil?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_imobil?.sector),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        numar_cadastral: new FormControl(this.inputData.data.nr_cadastral, Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        suprafata_teren: new FormControl(this.inputData.data.suprafata_teren),
        suprafata_constructie: new FormControl(this.inputData.data.suprafata_constructie),
        suprafata_desfasurata: new FormControl(this.inputData.data.suprafata_desfasurata),
        suprafata_utila: new FormControl(this.inputData.data.suprafata_utila),
        suprafata_bucatarii: new FormControl(this.inputData.data.suprafata_bucatarii),
        valoare: new FormControl(this.inputData.data.valuare, Validators.required),
        valabilitate: new FormControl(this.createDate(this.inputData.data.valability), Validators.required),
        durata_executie: new FormControl(this.inputData.data.durata_executie, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formAdminDrum: FormGroup = new FormGroup({
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_imobil?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_imobil?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_imobil?.sector),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        numar_cadastral: new FormControl(this.inputData.data.nr_cadastral, Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        suprafata_teren: new FormControl(this.inputData.data.suprafata_teren),
        suprafata_constructie: new FormControl(this.inputData.data.suprafata_constructie),
        suprafata_desfasurata: new FormControl(this.inputData.data.suprafata_desfasurata),
        suprafata_utila: new FormControl(this.inputData.data.suprafata_utila),
        suprafata_bucatarii: new FormControl(this.inputData.data.suprafata_bucatarii),
        valoare: new FormControl(this.inputData.data.valuare, Validators.required),
        valabilitate: new FormControl(this.createDate(this.inputData.data.valability), Validators.required),
        durata_executie: new FormControl(this.inputData.data.durata_executie, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formAvize: FormGroup = new FormGroup({
        numar_aviz: new FormControl(this.inputData.data.numar_aviz, Validators.required),
        data_intrarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        tip_persoana: new FormControl(this.inputData.data.tip_persoana, Validators.required),
        continut: new FormControl(this.inputData.data.continut, Validators.required),
        data_iesire: new FormControl(this.inputData.data.data_iesire, Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_lucrarii?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_lucrarii?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_lucrarii?.sector),
        strada: new FormControl(this.inputData.data.adresa_lucrarii?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_lucrarii?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_lucrarii?.bloc),
        scara: new FormControl(this.inputData.data.adresa_lucrarii?.scara),
        etaj: new FormControl(this.inputData.data.adresa_lucrarii?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_lucrarii?.apartament),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formAvizStudiuPub: FormGroup = new FormGroup({
        numar_aviz: new FormControl(this.inputData.data.numar_aviz, Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        beneficiar: new FormControl(this.inputData.data.beneficiar, Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_lucrarii?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_lucrarii?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_lucrarii?.sector),
        strada: new FormControl(this.inputData.data.adresa_lucrarii?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_lucrarii?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_lucrarii?.bloc),
        scara: new FormControl(this.inputData.data.adresa_lucrarii?.scara),
        etaj: new FormControl(this.inputData.data.adresa_lucrarii?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_lucrarii?.apartament),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formAvizPUD: FormGroup = new FormGroup({
        numar_aviz: new FormControl(this.inputData.data.numar_aviz, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        cnp_cui: new FormControl(this.inputData.data.cnp_cif, Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_imobil?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_imobil?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_imobil?.sector),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        suprafata_teren: new FormControl(this.inputData.data.suprafata_teren),
        suprafata_constructie: new FormControl(this.inputData.data.suprafata_constructie),
        suprafata_desfasurata: new FormControl(this.inputData.data.suprafata_desfasurata),
        suprafata_utila: new FormControl(this.inputData.data.suprafata_utila),
        suprafata_bucatarii: new FormControl(this.inputData.data.suprafata_bucatarii),
        nr_cad_teren: new FormControl(this.inputData.data.nr_cad_teren, Validators.required),
    });

    formSupraetajare: FormGroup = new FormGroup({
        numar_aviz: new FormControl(this.inputData.data.numar_aviz, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar),
        numar_cerere: new FormControl(this.inputData.data.cerere_id),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        cnp_cui: new FormControl(this.inputData.data.cnp_cif, Validators.required),
        judet: new FormControl(Number(this.inputData.data.adresa_imobil?.judet), [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl(this.inputData.data.adresa_imobil?.oras, Validators.required),
        sector: new FormControl(this.inputData.data.adresa_imobil?.sector),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        suprafata_teren: new FormControl(this.inputData.data.suprafata_teren),
        suprafata_constructie: new FormControl(this.inputData.data.suprafata_constructie),
        suprafata_desfasurata: new FormControl(this.inputData.data.suprafata_desfasurata),
        suprafata_utila: new FormControl(this.inputData.data.suprafata_utila),
        suprafata_bucatarii: new FormControl(this.inputData.data.suprafata_bucatarii),
        nr_cad_teren: new FormControl(this.inputData.data.nr_cad_teren, Validators.required),
    });

    formRegistruCU: FormGroup = new FormGroup({
        numar_certificat: new FormControl(this.inputData.data.registru_number, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar, Validators.required),
        numar_cerere: new FormControl(this.inputData.data.cerere_id, Validators.required),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        numar_cadastral: new FormControl(this.inputData.data.nr_cadastral, Validators.required),
        carte_funciara: new FormControl(this.inputData.data.carte_funciara, Validators.required),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formNotificari: FormGroup = new FormGroup({
        numar_notificare: new FormControl(this.inputData.data.registru_number, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar, Validators.required),
        numar_cerere: new FormControl(this.inputData.data.cerere_id, Validators.required),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        numar_cadastral: new FormControl(this.inputData.data.nr_cadastral, Validators.required),
        carte_funciara: new FormControl(this.inputData.data.carte_funciara, Validators.required),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    formAutorizatieConstruireDesfiintare: FormGroup = new FormGroup({
        numar_autorizatie: new FormControl(this.inputData.data.registru_number, Validators.required),
        data_eliberarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        numar_cerere_registratura: new FormControl(this.inputData.data.cerere_numar, Validators.required),
        numar_cerere: new FormControl(this.inputData.data.cerere_id, Validators.required),
        data_solicitarii: new FormControl(this.createDate(this.inputData.data.data_intrarii), Validators.required),
        strada: new FormControl(this.inputData.data.adresa_imobil?.strada, Validators.required),
        numar: new FormControl(this.inputData.data.adresa_imobil?.numar, Validators.required),
        bloc: new FormControl(this.inputData.data.adresa_imobil?.bloc),
        scara: new FormControl(this.inputData.data.adresa_imobil?.scara),
        etaj: new FormControl(this.inputData.data.adresa_imobil?.etaj),
        apartament: new FormControl(this.inputData.data.adresa_imobil?.apartament),
        numar_cadastral: new FormControl(this.inputData.data.nr_cadastral, Validators.required),
        solicitant: new FormControl(this.inputData.data.solicitant, Validators.required),
        scop: new FormControl(this.inputData.data.scop, Validators.required),
        suprafata_teren: new FormControl(this.inputData.data.suprafata_teren),
        suprafata_constructie: new FormControl(this.inputData.data.suprafata_constructie),
        suprafata_utila: new FormControl(this.inputData.data.suprafata_utila),
        suprafata_bucatarii: new FormControl(this.inputData.data.suprafata_bucatarii),
        valoare_lucrari: new FormControl(this.inputData.data.valoare_lucrari, Validators.required),
        valoare_taxa: new FormControl(this.inputData.data.valoare_taxa, Validators.required),
        valabilitate: new FormControl(this.createDate(this.inputData.data.valability), Validators.required),
        durata_executie: new FormControl(this.inputData.data.durata_executie, Validators.required),
        intocmitor: new FormControl(this.inputData.data.intocmitor, Validators.required),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public inputData: any,
        private dialogRef: MatDialogRef<EditRegistruComponent>,
        private registruService: RegistruService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
        this.initializeForm(this.inputData.slug);
        this.loadJudete();
        console.log(inputData);
    }

    initializeForm(id: string) {
        switch (id) {
            case 'acord_administrator_drum':
                // Administrator Drum
                this.form = this.getFormAdminDrum();
                break;
            case 'autorizatii-construire':
                // Autorizatii de construire
                this.form = this.getFormAutorizatiiConstruire();
                break;
            case 'avize':
                // Avize
                this.form = this.getFormAvize();
                break;
            case 'aviz-principiu-studiu-publicitar':
                // Aviz Studiu Publicitar
                this.form = this.getFormAvizStudiuPublicitar();
                break;
            case 'aviz-pud':
                // Aviz PUD
                this.form = this.getFormAvizPUD();
                break;
            case 'aviz-supraetajare':
                // Aviz Supraetajare
                this.form = this.getFormAvizSupraetajare();
                break;
            case 'certificate-urbanism':
                // Certificat de Urbanism
                this.form = this.getFormCertificatUrbanism();
                break;
            case 'construire_desfiintare':
                // Registru Construire/Desfiintare (CD)
                this.form = this.getFormRegistruCU();
                break;
            case 'construire_desfiintare_ingineresti':
                // Registru Construire/Desfiintare lucrari ingineresti (IN)
                this.form = this.getFormRegistruCU();
                break;
            case 'operatiuni_notariale':
                // Registru Operatiuni Notariale (OC)
                this.form = this.getFormRegistruCU();
                break;
            case 'certificate_urbanism_informare':
                // Registru CU de Informare (IF)
                this.form = this.getFormRegistruCU();
                break;
            case 'autorizatie_construire_desfiintare':
                // Registru Autorizatie de Construire/Desfiintare
                this.form = this.getFormAutorizatieConstruireDesfiintare();
                break;
            case 'notificari':
                // Registru Notificari
                this.form = this.getFormNotificari();
                break;
            default:
                console.log('Not recognized');
        }
    }

    getFormAdminDrum(): FormGroup {
        return this.formAdminDrum;
    }

    getFormAutorizatiiConstruire(): FormGroup {
        return this.formAutorizatiiConstruire;
    }

    getFormAvize(): FormGroup {
        return this.formAvize;
    }

    getFormAvizStudiuPublicitar(): FormGroup {
        return this.formAvizStudiuPub;
    }

    getFormAvizPUD(): FormGroup {
        return this.formAvizPUD;
    }

    getFormAvizSupraetajare(): FormGroup {
        return this.formSupraetajare;
    }

    getFormCertificatUrbanism(): FormGroup {
        return this.formCertificatUrbanism;
    }

    getFormRegistruCU(): FormGroup {
        return this.formRegistruCU;
    }

    getFormNotificari(): FormGroup {
        return this.formNotificari;
    }

    getFormAutorizatieConstruireDesfiintare(): FormGroup {
        return this.formAutorizatieConstruireDesfiintare;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.registruService.setToken(token);
        });
    }

    createDate(dateString: string) {
        if (dateString == null) {
            return '';
        }
        const [day, month, year] = dateString.split('.').map(Number);
        return new Date(year, month - 1, day);
    }

    submitForm() {
        this.isLoading = true;

        const formData = this.form.value;

        Object.keys(formData).forEach(key => {
            const value = formData[key];

            console.log(value);
            if (value instanceof Date) {
                formData[key] = this.formatDate(value);
                console.log(formData[key]);
            }
        });

        this.registruService
            .editRegistruDocOficial(formData, this.inputData.data.id)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    loadJudete() {
        this.registruService
            .getJudete()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]))
            .subscribe({
                next: (results) => {
                    this.judete = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                }
            })
    }
}
